module.exports = __webpack_public_path__ + "static/media/ic-camera-on-white.f8c6e00a.svg";